import '../scss/uncrustables.scss';

window.addEventListener('DOMContentLoaded', () => {
	const segments = document.querySelectorAll('.segment');
	if (segments) {
		segments.forEach(segment => {
			let segmentButton = segment.querySelector('[aria-role="button"]');
			segmentButton.addEventListener('click', () => {
				let drawerID = segmentButton.getAttribute('aria-controls');
				console.log('drawerID', drawerID);
				let drawer = document.getElementById(drawerID);
				drawer.toggleAttribute('hidden');
				segmentButton.toggleAttribute('aria-expanded');
				segment.classList.toggle('segment--open');
			});
		});
	}
	const floater = document.querySelector('.floater');
	const formSection = document.getElementById('rebate');
	let observer = new IntersectionObserver(callback, {
		root: null,
		rootMargin: '0px',
		threshold: 0,
	})
	if (formSection) {
		observer.observe(formSection);
	}
	function callback (entries, observer) {
		entries.forEach(entry => {
			// console.log('entry', entry);
			if (entry.isIntersecting) {
				floater.classList.add('floater-hide');
			} else {
				floater.classList.remove('floater-hide');
				if (entry.boundingClientRect.top < 0) {
					floater.classList.add('floater-below');
				} else {
					floater.classList.remove('floater-below');
				}
			}
		});
	}
});